/**
 * Builds the value a combobox shows for its selection: the first label alone, or
 * "First +N more" when several are picked. `moreLabel` is the translated word for "more".
 * A long first label is shortened so the +N count stays visible in the field.
 */
const MAX_FIRST_LABEL_LENGTH = 22

export function buildSelectionLabel(firstLabel: string | undefined, extraCount: number, moreLabel: string) {
  if (!firstLabel) return undefined
  if (extraCount <= 0) return firstLabel
  const label =
    firstLabel.length > MAX_FIRST_LABEL_LENGTH
      ? `${firstLabel.slice(0, MAX_FIRST_LABEL_LENGTH - 1)}\u2026`
      : firstLabel
  return `${label} +${extraCount} ${moreLabel}`
}
